import React, { useEffect, useState } from "react";
import "../Home/Home.css";
import { motion as m } from "framer-motion";
import { IoIosArrowForward } from "react-icons/io";
import { API_URL } from "../../Config";

const Careers = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [isPopup_thankYou, setPopup_thankYou] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const openPopup_thankYou = () => {
    setPopup_thankYou(true);
  };

  const closePopup_thankYou = () => {
    setPopup_thankYou(false);
  };

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
    role: "",
    resume: null,
  });
  const [contactError, setContactError] = useState("");
  const [contactSuccess, setContactSuccess] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "phone") {
      const cleanedValue = value.replace(/\D/g, "");
      const limitedValue = cleanedValue.slice(0, 10);
      setFormData((prevState) => ({
        ...prevState,
        [name]: limitedValue,
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const validateEmailInForm = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePhoneNumber = (phone) => {
    const phoneRegex = /^\d{10}$/;
    return phoneRegex.test(phone);
  };

  const validateContactForm = () => {
    let formErrors = {};

    if (!formData.firstName.trim()) {
      formErrors.firstName = "First name is required.";
    }
    if (!formData.lastName.trim()) {
      formErrors.lastName = "Last name is required.";
    }
    if (!validateEmailInForm(formData.email)) {
      formErrors.email = "Please enter a valid email address.";
    }
    if (!validatePhoneNumber(formData.phone)) {
      formErrors.phone = "Please enter a valid phone number (10 digits).";
    }
    if (!formData.role.trim()) {
      formErrors.role = "Role is required.";
    }
    if (
      Object.keys(formErrors).length === 0 &&
      (!formData.firstName.trim() ||
        !formData.lastName.trim() ||
        !formData.email ||
        !formData.phone)
    ) {
      return { general: "Please fill out all fields." };
    }

    return formErrors;
  };

  // const handleContactSubmit = async (e) => {
  //   e.preventDefault();
  //   const formErrors = validateContactForm();

  //   if (formErrors.general) {
  //     setContactError(formErrors.general);
  //     setContactSuccess("");
  //     console.log("Form submission error:", formErrors.general);
  //     setFormData({
  //       firstName: "",
  //       lastName: "",
  //       email: "",
  //       phone: "",
  //       message: "",
  //       role: "",
  //       resume: null,
  //     });
  //     setTimeout(() => {
  //       setContactError("");
  //     }, 8000);
  //   } else if (Object.keys(formErrors).length > 0) {
  //     setContactError(Object.values(formErrors).join(" "));
  //     setContactSuccess("");
  //     console.log("Form submission errors:", formErrors);
  //     setFormData({
  //       firstName: "",
  //       lastName: "",
  //       email: "",
  //       phone: "",
  //       message: "",
  //       role: "",
  //       resume: null,
  //     });
  //     setTimeout(() => {
  //       setContactError("");
  //     }, 8000);
  //   } else {
  //     setContactError("");
  //     setContactSuccess("Your message has been sent successfully!");

  //     const formDataToSend = new FormData();
  //     formDataToSend.append("firstName", formData.firstName);
  //     formDataToSend.append("lastName", formData.lastName);
  //     formDataToSend.append("email", formData.email);
  //     formDataToSend.append("phone", formData.phone);
  //     formDataToSend.append("message", formData.message);
  //     formDataToSend.append("role", formData.role);
  //     if (formData.resume) {
  //       formDataToSend.append("resume", formData.resume);
  //     }

  //     try {
  //       const response = await fetch(API_URL + "/send-email-careers", {
  //         method: "POST",
  //         body: formDataToSend,
  //       });

  //       if (response.ok) {
  //         console.log("Email sent successfully");
  //         openPopup_thankYou();
  //       } else {
  //         console.log("Failed to send email");
  //       }
  //     } catch (error) {
  //       console.log("Error:", error);
  //     }

  //     setFormData({
  //       firstName: "",
  //       lastName: "",
  //       email: "",
  //       phone: "",
  //       message: "",
  //       role: "",
  //       resume: null,
  //     });
  //     setTimeout(() => {
  //       setContactSuccess("");
  //     }, 20000);
  //   }
  // };

  // const [isUploading, setIsUploading] = useState(false);
  const handleContactSubmit = async (e) => {
    e.preventDefault();

    const formErrors = validateContactForm();
    if (Object.keys(formErrors).length > 0) {
      setContactError(Object.values(formErrors).join(" "));
      return;
    }

    setContactError("");
    setContactSuccess("");
    setIsLoading(true);

    const formDataToSend = new FormData();
    formDataToSend.append("firstName", formData.firstName);
    formDataToSend.append("lastName", formData.lastName);
    formDataToSend.append("email", formData.email);
    formDataToSend.append("phone", formData.phone);
    formDataToSend.append("message", formData.message);
    formDataToSend.append("role", formData.role);
    if (formData.resume) {
      formDataToSend.append("resume", formData.resume);
    }

    try {
      const response = await fetch(API_URL + "/send-email-careers", {
        method: "POST",
        body: formDataToSend,
      });

      if (!response.ok) {
        throw new Error("Failed to send email");
      }

      // ✅ SUCCESS
      openPopup_thankYou(); // show popup AFTER success
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        message: "",
        role: "",
        resume: null,
      });
    } catch (error) {
      console.error(error);
      setContactError("Failed to send resume. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // setIsUploading(true);
      if (validateFile(file)) {
        setFormData((prevState) => ({
          ...prevState,
          resume: file,
        }));
        // setIsUploading(false);
      } else {
        setContactError("Please upload a valid file (PNG, JPG, JPEG, or PDF).");
        // setIsUploading(false);
      }
    }
  };

  const validateFile = (file) => {
    const allowedTypes = ["image/png", "image/jpeg", "application/pdf"];
    return allowedTypes.includes(file.type);
  };

  useEffect(() => {
    if (isPopup_thankYou) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isPopup_thankYou]);

  return (
    <m.div
      initial={{ opacity: 0 }}
      animate={{ opacity: [0, 0.5, 1] }}
      transition={{ duration: 0.9, ease: "easeIn" }}
      style={{ willChange: "opacity" }}
    >
      <div className="bg-white dark:bg-black dark:text-white transition-all duration-300 ease-in-out">
        {/* Banner */}
        <div className="px-5 lg:px-[7%] 2xl:px-[13%] py-10 pt-32">
          <div className="card_titleBanner relative w-full pt-14 pb-12 group rounded-lg overflow-hidden flex flex-col bg-gray-100 text-gray-900 dark:bg-neutral-800 border border-gray-100 dark:border-gray-800 text-left p-3 dark:text-gray-50 text-base font-bold transition-all duration-300 ease-in-out">
            <div className="flex flex-col sm:items-center">
              <p className="font-semibold uppercase text-3xl lg:text-4xl transition-all duration-200 ease-in-out">
                Careers
                <div className="flex h-0.5 w-10 mt-0.5 bg-teal-600 rounded-full" />
              </p>

              <p className="flex items-center gap-1 mt-3 text-sm">
                Home <IoIosArrowForward className="text-teal-600" />
                <i>Careers</i>
              </p>
            </div>
          </div>
        </div>

        {/* Form */}
        <div className="px-5 lg:px-[15%] 2xl:px-[20%] py-10">
          <div className="grid grid-cols-1 sm:grid-cols-2 items-center gap-x-10 gap-y-10">
            <div>
              <p className="text-sm 2xl:text-lg font-semibold text-gray-500">
                First Name*
              </p>
              <input
                className="w-full mt-1 md:mt-2 p-1 md:p-2 outline-none bg-transparent"
                type="text"
                name="firstName"
                placeholder="Enter first name"
                value={formData.firstName}
                onChange={handleInputChange}
                tabIndex="1"
                required
              />
              <div className="mt-1 h-[2px] bg-[#008080]"></div>
            </div>

            <div>
              <p className="text-sm 2xl:text-lg font-semibold text-gray-500">
                Last Name*
              </p>
              <input
                className="w-full mt-1 md:mt-2 p-1 md:p-2 outline-none bg-transparent"
                type="text"
                name="lastName"
                placeholder="Enter last name"
                value={formData.lastName}
                onChange={handleInputChange}
                tabIndex="2"
                required
              />
              <div className="mt-1 h-[2px] bg-[#008080]"></div>
            </div>

            <div>
              <p className="text-sm 2xl:text-lg font-semibold text-gray-500">
                Email*
              </p>
              <input
                className="w-full mt-1 md:mt-2 p-1 md:p-2 outline-none bg-transparent"
                type="text"
                name="email"
                placeholder="Enter email"
                value={formData.email}
                onChange={handleInputChange}
                tabIndex="3"
                required
              />
              <div className="mt-1 h-[2px] bg-[#008080]"></div>
            </div>

            <div>
              <p className="text-sm 2xl:text-lg font-semibold text-gray-500">
                Phone No.*
              </p>
              <input
                className="w-full mt-1 md:mt-2 p-1 md:p-2 outline-none bg-transparent"
                type="text"
                name="phone"
                placeholder="Enter phone no."
                pattern="\d{10}"
                value={formData.phone}
                onChange={handleInputChange}
                tabIndex="4"
                required
              />
              <div className="mt-1 h-[2px] bg-[#008080]"></div>
            </div>

            <div>
              <p className="text-sm 2xl:text-lg font-semibold text-gray-500">
                Role you want to apply for*
              </p>
              <input
                className="w-full mt-1 md:mt-2 p-1 md:p-2 outline-none bg-transparent"
                type="text"
                name="role"
                placeholder="Enter role"
                value={formData.role}
                onChange={handleInputChange}
                tabIndex="5"
                required
              />
              <div className="mt-1 h-[2px] bg-[#008080]"></div>
            </div>

            {/* <div className='mt-12 lg:my-14 2xl:my-28'>
                    <p className='text-sm 2xl:text-lg font-semibold text-gray-500'>Upload your resume here*</p>
                    <div className='h-7 lg:h-10'>
                        <a href="/"><img className="h-6 lg:h-8 mt-3 ml-1 2xl:mt-5" src="../assets/cloud_icon.webp" alt="cloud"></img></a>
                    </div>
                    <div className='mt-1 md:mt-5 lg:mt-1 h-[2px] bg-[#008080]'></div>
                </div> */}

            <div>
              <p className="text-sm 2xl:text-lg font-semibold text-gray-500">
                Upload your resume here*
              </p>
              <div className="flex items-center gap-1">
                <img
                  className="h-6 lg:h-8"
                  src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/41d007e0-70ba-43ca-16dd-29d8648eaf00/public"
                  alt="cloud"
                />{" "}
                {/* init_cloud_icon.webp */}
                <input
                  className="w-full p-1 md:p-2 outline-none bg-transparent cursor-pointer"
                  type="file"
                  name="resume"
                  accept=".png, .jpg, .jpeg, .pdf"
                  onChange={handleFileChange}
                  tabIndex="6"
                  required
                />
                {/* {isUploading && (
                    <div className="loader ml-2 text-red-500">Uploading...</div>
                )} */}
              </div>
              <div className="mt-1 lg:mt-1 h-[2px] bg-[#008080]"></div>
            </div>

            <div className="sm:col-span-2">
              <p className="text-sm 2xl:text-lg font-semibold text-gray-500">
                Message (optional)
              </p>
              <textarea
                className="w-full mt-2 md:mt-2 p-1 md:p-2 outline-none bg-transparent"
                type="text"
                name="message"
                placeholder="Enter message"
                value={formData.message}
                onChange={handleInputChange}
                tabIndex="7"
              />
              <div className="mt-1 h-[2px] bg-[#008080]"></div>
            </div>
          </div>

          {/*     <div className="relative group mt-10 flex justify-end">
            <button
              className="relative inline-block p-px text-white bg-[#008080] cursor-default rounded-lg shadow-emerald-900 transition-all duration-300 ease-in-out hover:scale-105 active:scale-95 hover:shadow-emerald-600"
              onClick={handleContactSubmit}
                disabled={isLoading}
              //   onClick={openPopup_thankYou}
              //   type="submit"
            >
              <span className="absolute inset-0 rounded-lg bg-gradient-to-r from-teal-100 via-teal-300 to-teal-500 p-[2px] opacity-0 transition-opacity duration-500 group-hover:opacity-100"></span>
              <span className="relative z-10 block px-4 py-2 rounded-lg bg-[#008080]">
                <div className="relative z-10 flex items-center space-x-3">
                  <span className="font-medium transition-all duration-500 group-hover:translate-x-0 text-sm group-hover:text-white">
                    Send my resume!
                  </span>
                </div>
              </span>
            </button>
          </div>
*/}
          <div className="relative group mt-10 flex justify-end">
            <button
              className={`relative inline-block p-px text-white bg-[#008080] rounded-lg shadow-emerald-900 
      transition-all duration-300 ease-in-out hover:scale-105 active:scale-95 hover:shadow-emerald-600
      ${isLoading ? "cursor-not-allowed opacity-80" : "cursor-default"}`}
              onClick={handleContactSubmit}
              disabled={isLoading}
            >
              <span className="absolute inset-0 rounded-lg bg-gradient-to-r from-teal-100 via-teal-300 to-teal-500 p-[2px] opacity-0 transition-opacity duration-500 group-hover:opacity-100"></span>

              <span className="relative z-10 block px-4 py-2 rounded-lg bg-[#008080]">
                <div className="relative z-10 flex items-center space-x-3">
                  {isLoading ? (
                    <>
                      {/* Tailwind Loader */}
                      <span className="w-4 h-4 border-2 border-white/40 border-t-white rounded-full animate-spin"></span>
                      <span className="font-medium text-sm">Sending…</span>
                    </>
                  ) : (
                    <span className="font-medium transition-all duration-500 group-hover:translate-x-0 text-sm group-hover:text-white">
                      Send my resume!
                    </span>
                  )}
                </div>
              </span>
            </button>
          </div>

          {contactError && (
            <p className="text-red-500 mt-2 tex-center">{contactError}</p>
          )}
          {contactSuccess && (
            <p className="text-green-500 mt-2 text-center">{contactSuccess}</p>
          )}

          {isPopup_thankYou && (
            <>
              {/* Overlay */}
              <div
                className="fixed inset-0 bg-black/60 z-50"
                onClick={closePopup_thankYou}
              />

              {/* Popup Wrapper */}
              <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
                <div
                  className="relative bg-white dark:bg-[#252525] w-full max-w-md rounded-xl shadow-2xl p-6 md:p-8"
                  onClick={(e) => e.stopPropagation()}
                >
                  {/* Close Button */}
                  <button
                    className="absolute top-2 right-3 text-gray-500 dark:text-gray-300 hover:text-black dark:hover:text-white text-2xl"
                    onClick={closePopup_thankYou}
                  >
                    &times;
                  </button>

                  {/* Content */}
                  <div className="text-black">
                    <p className="text-lg md:text-2xl dark:text-white font-semibold">
                      Thank you for your response!
                    </p>

                    <p className="mt-3 text-gray-600 dark:text-gray-300">
                      Your resume has been successfully sent.
                    </p>

                    <div className="flex justify-center mt-8">
                      {/* <button
                        onClick={closePopup_thankYou}
                        className="px-6 py-2 rounded-lg bg-[#008080] text-white font-medium transition-all duration-300 hover:scale-105 active:scale-95"
                      >
                        Done
                      </button> */}

                      <div className="relative group flex justify-end">
                        <button
                          className="relative inline-block p-px text-white bg-[#008080] cursor-default rounded-lg shadow-emerald-900 transition-all duration-300 ease-in-out hover:scale-105 active:scale-95 hover:shadow-emerald-600"
                          onClick={closePopup_thankYou}
                        >
                          <span className="absolute inset-0 rounded-lg bg-gradient-to-r from-teal-100 via-teal-300 to-teal-500 p-[2px] opacity-0 transition-opacity duration-500 group-hover:opacity-100"></span>
                          <span className="relative z-10 block px-4 py-2 rounded-lg bg-[#008080]">
                            <div className="relative z-10 flex items-center space-x-3">
                              <span className="font-medium transition-all duration-500 group-hover:translate-x-0 text-sm group-hover:text-white">
                                Done
                              </span>
                            </div>
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </m.div>
  );
};

export default Careers;
